import { render, staticRenderFns } from "./DashboardWidgetTable.vue?vue&type=template&id=3cf13320&scoped=true&"
import script from "./DashboardWidgetTable.vue?vue&type=script&lang=js&"
export * from "./DashboardWidgetTable.vue?vue&type=script&lang=js&"
import style0 from "./DashboardWidgetTable.vue?vue&type=style&index=0&id=3cf13320&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf13320",
  null
  
)

export default component.exports